<template>
    <div class="vidalitics_video_player">
        <iframe :src="video_source" loading="lazy" style="border:0;position:relative;top:0;height:70vh;width:100%;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowfullscreen="true">
        </iframe>
    </div>
</template>
  
<script>
export default {
name: 'BunnyCDNVideo',
props: {
    videoId: {
      type: String,
      required: true,
    },
},
data() {
  return {
    video_source: 'https://iframe.mediadelivery.net/embed/454039/' + this.videoId +'?autoplay=true&loop=false&muted=true&preload=true&responsive=true'
  }
},
created() {
}
}
</script>  
<style>
.vidalitics_video_player{
    /* max-width: 200px;
    max-height: 400px; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 1rem; */
    width: 50%;
    height: 90vh; /* Optional: Makes container take full height of the screen */
    box-sizing: border-box;
    margin: 0 auto;
}
@media (max-width: 80em) {
    .vidalitics_video_player{
        width: 75%;
    }
}
@media (max-width: 47.999em) {
    .vidalitics_video_player{
        width: 100%;
        height: auto;
        /* height: 100vh;  */
        /* Optional: Makes container take full height of the screen */
    }
}
</style>